import axios from 'axios';
import { ILog, ITransportFn, IBrowserConsoleTransportFn } from '@nab/nab-x-sdk-core';

/**
 * A `Logger` transport function for the browser `console`.
 * @param logs
 */
export const consoleTransport: IBrowserConsoleTransportFn = function consoleTransport(logs: ILog[]) {
    return new Promise<void>((resolve) => {
        logs.forEach((log) => {
            const { level, message, category, timestamp } = log;
            console[level](category, message, timestamp, log); // eslint-disable-line
        });
        resolve();
    });
};

consoleTransport.prototype.isBrowserConsoleTransport = true as true;

/**
 * Curried transport function for Splunk.
 * The Splunk transport is currently intended for frontend only, and for internal use such as nabONE.
 *
 * graphql/express serverside logs should go to console->cloudwatch->splunk lambda->splunk
 *
 * @example
 * ```
 *  const appSplunkTransport = splunkTransport(env.splunk.endpoint, env.splunk.token);
 *
 *  const transports = {
 *    [LogEventEnum.analytics]: appSplunkTransport,
 *    ...otherEventTransports
 *   }
 * ```
 * @export
 * @param {string} endpoint
 * @param {string} token
 * @returns
 */
function splunkTransport(endpoint: string, token: string) {
    // create a separate instance of axios so that it is not affected by any issues on the default Axios instance. #DIGF1-741
    const splunkTransportHttpClient = axios.create();

    const postToSplunk: ITransportFn = function postToSplunk(logs: ILog[]) {
        return splunkTransportHttpClient.post(endpoint, JSON.stringify(logs), {
            headers: {
                Authorization: `Splunk ${token}`,
                // Splunk ~6.4 does not allow the Content-Type header is its CORS accept configuration.
                // Unfortunately this forces a pre-flight CORS OPTIONS check.
                'Content-Type': undefined
            }
        });
    };
    return postToSplunk;
}

export { splunkTransport }; // eslint-disable-line
